import React, { useState } from "react";
import { updateData } from "../../utility/adminApi";
import CancelIcon from "@mui/icons-material/Cancel";

function EditCategory({
  singleData,
  setSingleData,
  fetchCategories,
  setEdittab,
  currentPage,
}) {
  const [loading, setLoading] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target; // Destructure name and value from event target
    setSingleData((prevData) => ({
      ...prevData,
      [name]: value, // Update the corresponding field in state
    }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const keysToExtract = ["cat_name", "short_description"];
    const newSingleData = Object.keys(singleData).reduce((result, key) => {
      if (keysToExtract.includes(key)) {
        result[key] = singleData[key];
      }
      return result;
    }, {});

    const response = await updateData(
      "categories/update/",
      singleData.id,
      newSingleData,
    );
    let errorCheck = response?.response?.data?.error;

    if (errorCheck) {
      setLoading(false);
    } else {
      fetchCategories(currentPage);
      setEdittab(false);
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-md">
      <div className="flex justify-end">
        <CancelIcon
          className="cursor-pointer"
          onClick={() => setEdittab(false)}
        />
      </div>

      <h2 className="text-2xl font-medium text-center">Edit Category </h2>
      <form
        onSubmit={handleEditSubmit}
        className="py-12  flex flex-col justify-center items-center gap-6 "
      >
        <div className="flex flex-col gap-6 ">
          <div className="flex flex-col">
            <label htmlFor="">Category</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="Category Name"
              type="text "
              name="cat_name"
              // id="email"
              value={singleData.cat_name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="">Short Description</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md focus:border-gray-500 focus:outline-none lg:w-[400px]"
              placeholder="Short Description"
              type="text"
              // id="email"
              name="short_description"
              value={singleData.short_description}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <button
          disabled={loading}
          type="submit"
          className="px-4 py-3 text-white rounded-lg w-full lg:w-[400px] bg-blue-500"
        >
          {loading ? "Submitting.." : "Submit"}
        </button>
      </form>
    </div>
  );
}

export default EditCategory;
